import { Element } from "@siteimprove/alfa-dom";
import { Maybe, None, Option } from "@siteimprove/alfa-option";
import { Universal } from "../../index.js";
import { WithIndexAndSelector } from "./pseudo-class.js";
const { isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#nth-child-pseudo}
 */
export class NthChild extends WithIndexAndSelector {
    static of(index, selector = None) {
        return new NthChild(index, Maybe.toOption(selector));
    }
    _indices = new WeakMap();
    constructor(index, selector) {
        super("nth-child", index, selector);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context) {
        if (!this._indices.has(element)) {
            element
                .inclusiveSiblings()
                .filter(isElement)
                .filter((element) => this._selector
                .getOr(Universal.of(Option.of("*")))
                .matches(element, context))
                .forEach((element, i) => {
                this._indices.set(element, i + 1);
            });
        }
        if (!this._indices.has(element)) {
            return false;
        }
        return this._index.matches(this._indices.get(element));
    }
    equals(value) {
        return value instanceof NthChild && super.equals(value);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (NthChild) {
    NthChild.parse = (parseSelector) => WithIndexAndSelector.parseWithIndexAndSelector("nth-child", parseSelector, NthChild.of);
})(NthChild || (NthChild = {}));
//# sourceMappingURL=nth-child.js.map